import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  appStore: {
    id: 'app_store',
  },
  downloadFrom: {
    id: 'download',
  },
});
